import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireProfile = true }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/', { replace: true });
    } else if (!loading && user && requireProfile && (!user.profile_completed || !user.birth_year || !user.tos_accepted)) {
      navigate('/setup-profilo', { replace: true });
    }
  }, [user, loading, navigate, requireProfile]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center" style={{ fontFamily: "'Outfit', sans-serif" }}>
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#FDE047] border-t-[#0A0A0A] rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#0A0A0A] font-medium">Caricamento...</p>
        </div>
      </div>
    );
  }

  if (!user) return null;
  if (requireProfile && (!user.profile_completed || !user.birth_year || !user.tos_accepted)) return null;

  return children;
};

export default ProtectedRoute;
